/**
 * Bundled list of Google Fonts so the dialog works without any cross-origin
 * fetch to fonts.google.com (which blocks CORS requests from web apps).
 *
 * Source: https://fonts.google.com  (curated popular/useful subset)
 * To update: run `node scripts/fetchGoogleFonts.js` (or add entries manually).
 */

export interface GFontMeta {
  family: string;
  /** CSS generic family */
  category: "sans-serif" | "serif" | "display" | "handwriting" | "monospace";
}

export const GOOGLE_FONTS_LIST: GFontMeta[] = [
  // Sans-serif
  { family: "ABeeZee", category: "sans-serif" },
  { family: "Abel", category: "sans-serif" },
  { family: "Acme", category: "sans-serif" },
  { family: "Alata", category: "sans-serif" },
  { family: "Albert Sans", category: "sans-serif" },
  { family: "Alegreya Sans", category: "sans-serif" },
  { family: "Alef", category: "sans-serif" },
  { family: "Alice", category: "serif" },
  { family: "Alike", category: "serif" },
  { family: "Alkatra", category: "display" },
  { family: "Allan", category: "display" },
  { family: "Allura", category: "handwriting" },
  { family: "Almarai", category: "sans-serif" },
  { family: "Almendra", category: "serif" },
  { family: "Alumni Sans", category: "sans-serif" },
  { family: "Amatic SC", category: "handwriting" },
  { family: "Amethysta", category: "serif" },
  { family: "Amiri", category: "serif" },
  { family: "Amita", category: "handwriting" },
  { family: "Anaheim", category: "sans-serif" },
  { family: "Andada Pro", category: "serif" },
  { family: "Andika", category: "sans-serif" },
  { family: "Anek Bangla", category: "sans-serif" },
  { family: "Anek Devanagari", category: "sans-serif" },
  { family: "Angkor", category: "display" },
  { family: "Annie Use Your Telescope", category: "handwriting" },
  { family: "Anonymous Pro", category: "monospace" },
  { family: "Antic", category: "sans-serif" },
  { family: "Anton", category: "sans-serif" },
  { family: "Antonio", category: "sans-serif" },
  { family: "Anything", category: "handwriting" },
  { family: "Archivo", category: "sans-serif" },
  { family: "Archivo Black", category: "sans-serif" },
  { family: "Archivo Narrow", category: "sans-serif" },
  { family: "Are You Serious", category: "handwriting" },
  { family: "Aref Ruqaa", category: "serif" },
  { family: "Arima", category: "display" },
  { family: "Arimo", category: "sans-serif" },
  { family: "Arizonia", category: "handwriting" },
  { family: "Armata", category: "sans-serif" },
  { family: "Arsenal", category: "sans-serif" },
  { family: "Artifika", category: "serif" },
  { family: "Arvo", category: "serif" },
  { family: "Asap", category: "sans-serif" },
  { family: "Asap Condensed", category: "sans-serif" },
  { family: "Asset", category: "display" },
  { family: "Assistant", category: "sans-serif" },
  { family: "Astloch", category: "display" },
  { family: "Asul", category: "sans-serif" },
  { family: "Atomic Age", category: "display" },
  { family: "Aubrey", category: "display" },
  { family: "Audiowide", category: "display" },
  { family: "Autour One", category: "display" },
  { family: "Average", category: "serif" },
  { family: "Average Sans", category: "sans-serif" },
  { family: "Averia Gruesa Libre", category: "display" },
  { family: "Averia Libre", category: "display" },
  { family: "Averia Sans Libre", category: "display" },
  { family: "Averia Serif Libre", category: "display" },
  // B
  { family: "B612", category: "sans-serif" },
  { family: "B612 Mono", category: "monospace" },
  { family: "BIZ UDGothic", category: "sans-serif" },
  { family: "BIZ UDMincho", category: "serif" },
  { family: "Babylonica", category: "handwriting" },
  { family: "Bacasime Antique", category: "serif" },
  { family: "Bad Script", category: "handwriting" },
  { family: "Bagel Fat One", category: "display" },
  { family: "Bahiana", category: "display" },
  { family: "Bahianita", category: "display" },
  { family: "Bai Jamjuree", category: "sans-serif" },
  { family: "Ballet", category: "display" },
  { family: "Baloo 2", category: "display" },
  { family: "Baloo Bhai 2", category: "display" },
  { family: "Baloo Bhaina 2", category: "display" },
  { family: "Baloo Chettan 2", category: "display" },
  { family: "Baloo Da 2", category: "display" },
  { family: "Baloo Tammudu 2", category: "display" },
  { family: "Baloo Thambi 2", category: "display" },
  { family: "Balsamiq Sans", category: "display" },
  { family: "Balthazar", category: "serif" },
  { family: "Bangers", category: "display" },
  { family: "Barlow", category: "sans-serif" },
  { family: "Barlow Condensed", category: "sans-serif" },
  { family: "Barlow Semi Condensed", category: "sans-serif" },
  { family: "Barriecito", category: "display" },
  { family: "Barrio", category: "display" },
  { family: "Basic", category: "sans-serif" },
  { family: "Baskervville", category: "serif" },
  { family: "Battambang", category: "display" },
  { family: "Baumans", category: "display" },
  { family: "Bayon", category: "sans-serif" },
  { family: "Be Vietnam Pro", category: "sans-serif" },
  { family: "Beau Rivage", category: "handwriting" },
  { family: "Bebas Neue", category: "display" },
  { family: "Bellefair", category: "serif" },
  { family: "Belleza", category: "sans-serif" },
  { family: "Bellota", category: "display" },
  { family: "Bellota Text", category: "display" },
  { family: "BenchNine", category: "sans-serif" },
  { family: "Benne", category: "serif" },
  { family: "Bentham", category: "serif" },
  { family: "Berkshire Swash", category: "handwriting" },
  { family: "Besley", category: "serif" },
  { family: "Beth Ellen", category: "handwriting" },
  { family: "Bevan", category: "serif" },
  { family: "BhuTuka Expanded One", category: "serif" },
  { family: "Big Shoulders Display", category: "display" },
  { family: "Big Shoulders Inline Display", category: "display" },
  { family: "Big Shoulders Inline Text", category: "display" },
  { family: "Big Shoulders Stencil Display", category: "display" },
  { family: "Big Shoulders Stencil Text", category: "display" },
  { family: "Big Shoulders Text", category: "display" },
  { family: "Bigelow Rules", category: "display" },
  { family: "Bigshot One", category: "display" },
  { family: "Bilbo", category: "handwriting" },
  { family: "Bilbo Swash Caps", category: "handwriting" },
  { family: "BioRhyme", category: "serif" },
  { family: "BioRhyme Expanded", category: "serif" },
  { family: "Birthstone", category: "handwriting" },
  { family: "Birthstone Bounce", category: "handwriting" },
  { family: "Biryani", category: "sans-serif" },
  { family: "Bitter", category: "serif" },
  { family: "Black And White Picture", category: "serif" },
  { family: "Black Han Sans", category: "sans-serif" },
  { family: "Black Ops One", category: "display" },
  { family: "Blinker", category: "sans-serif" },
  { family: "Bodoni Moda", category: "serif" },
  { family: "Bokor", category: "display" },
  { family: "Boogaloo", category: "display" },
  { family: "Borel", category: "handwriting" },
  { family: "Bowlby One", category: "display" },
  { family: "Bowlby One SC", category: "display" },
  { family: "Braah One", category: "sans-serif" },
  { family: "Brawler", category: "serif" },
  { family: "Bree Serif", category: "serif" },
  { family: "Bricolage Grotesque", category: "sans-serif" },
  { family: "Bruno Ace", category: "display" },
  { family: "Bruno Ace SC", category: "display" },
  { family: "Brygada 1918", category: "serif" },
  { family: "Bubblegum Sans", category: "display" },
  { family: "Bubbler One", category: "sans-serif" },
  { family: "Buda", category: "display" },
  { family: "Buenard", category: "serif" },
  { family: "Bungee", category: "display" },
  { family: "Bungee Hairline", category: "display" },
  { family: "Bungee Inline", category: "display" },
  { family: "Bungee Outline", category: "display" },
  { family: "Bungee Shade", category: "display" },
  { family: "Bungee Spice", category: "display" },
  { family: "Butcherman", category: "display" },
  { family: "Butterfly Kids", category: "handwriting" },
  // C
  { family: "Cabin", category: "sans-serif" },
  { family: "Cabin Condensed", category: "sans-serif" },
  { family: "Cabin Sketch", category: "display" },
  { family: "Caesar Dressing", category: "display" },
  { family: "Cagliostro", category: "sans-serif" },
  { family: "Cairo", category: "sans-serif" },
  { family: "Cairo Play", category: "sans-serif" },
  { family: "Caladea", category: "serif" },
  { family: "Calistoga", category: "display" },
  { family: "Calligraffitti", category: "handwriting" },
  { family: "Cambay", category: "sans-serif" },
  { family: "Cambo", category: "serif" },
  { family: "Candal", category: "sans-serif" },
  { family: "Cantarell", category: "sans-serif" },
  { family: "Cantata One", category: "serif" },
  { family: "Cantora One", category: "sans-serif" },
  { family: "Caprasimo", category: "display" },
  { family: "Capriola", category: "sans-serif" },
  { family: "Caramel", category: "handwriting" },
  { family: "Carattere", category: "handwriting" },
  { family: "Cardo", category: "serif" },
  { family: "Carlito", category: "sans-serif" },
  { family: "Carme", category: "sans-serif" },
  { family: "Carrois Gothic", category: "sans-serif" },
  { family: "Carrois Gothic SC", category: "sans-serif" },
  { family: "Carter One", category: "display" },
  { family: "Castoro", category: "serif" },
  { family: "Castoro Titling", category: "display" },
  { family: "Catamaran", category: "sans-serif" },
  { family: "Caudex", category: "serif" },
  { family: "Caveat", category: "handwriting" },
  { family: "Caveat Brush", category: "handwriting" },
  { family: "Cedarville Cursive", category: "handwriting" },
  { family: "Ceviche One", category: "display" },
  { family: "Chakra Petch", category: "sans-serif" },
  { family: "Changa", category: "sans-serif" },
  { family: "Changa One", category: "display" },
  { family: "Chango", category: "display" },
  { family: "Charis SIL", category: "serif" },
  { family: "Charm", category: "handwriting" },
  { family: "Charmonman", category: "handwriting" },
  { family: "Chathura", category: "sans-serif" },
  { family: "Chau Philomene One", category: "sans-serif" },
  { family: "Chela One", category: "display" },
  { family: "Chelsea Market", category: "display" },
  { family: "Cherry Bomb One", category: "display" },
  { family: "Cherry Cream Soda", category: "display" },
  { family: "Cherry Swash", category: "display" },
  { family: "Chewy", category: "display" },
  { family: "Chicle", category: "display" },
  { family: "Chilanka", category: "handwriting" },
  { family: "Chivo", category: "sans-serif" },
  { family: "Chivo Mono", category: "monospace" },
  { family: "Chokokutai", category: "display" },
  { family: "Chonburi", category: "display" },
  { family: "Cinzel", category: "serif" },
  { family: "Cinzel Decorative", category: "display" },
  { family: "Clicker Script", category: "handwriting" },
  { family: "Coda", category: "display" },
  { family: "Codystar", category: "display" },
  { family: "Coiny", category: "display" },
  { family: "Combo", category: "display" },
  { family: "Comfortaa", category: "display" },
  { family: "Comforter", category: "handwriting" },
  { family: "Comforter Brush", category: "handwriting" },
  { family: "Comic Neue", category: "handwriting" },
  { family: "Coming Soon", category: "handwriting" },
  { family: "Como", category: "sans-serif" },
  { family: "Compugraphic Dingbats", category: "display" },
  { family: "Comfortaa", category: "display" },
  { family: "Concert One", category: "display" },
  { family: "Condiment", category: "handwriting" },
  { family: "Content", category: "display" },
  { family: "Contrail One", category: "display" },
  { family: "Convergence", category: "sans-serif" },
  { family: "Cookie", category: "handwriting" },
  { family: "Copse", category: "serif" },
  { family: "Corben", category: "display" },
  { family: "Corinthia", category: "handwriting" },
  { family: "Cormorant", category: "serif" },
  { family: "Cormorant Garamond", category: "serif" },
  { family: "Cormorant Infant", category: "serif" },
  { family: "Cormorant SC", category: "serif" },
  { family: "Cormorant Unicase", category: "serif" },
  { family: "Cormorant Upright", category: "serif" },
  { family: "Courgette", category: "handwriting" },
  { family: "Courier Prime", category: "monospace" },
  { family: "Cousine", category: "monospace" },
  { family: "Coustard", category: "serif" },
  { family: "Covered By Your Grace", category: "handwriting" },
  { family: "Crafty Girls", category: "handwriting" },
  { family: "Creepster", category: "display" },
  { family: "Crete Round", category: "serif" },
  { family: "Crimson Pro", category: "serif" },
  { family: "Crimson Text", category: "serif" },
  { family: "Croissant One", category: "display" },
  { family: "Crushed", category: "display" },
  { family: "Cuprum", category: "sans-serif" },
  { family: "Cute Font", category: "display" },
  { family: "Cutive", category: "serif" },
  { family: "Cutive Mono", category: "monospace" },
  // D
  { family: "DM Mono", category: "monospace" },
  { family: "DM Sans", category: "sans-serif" },
  { family: "DM Serif Display", category: "serif" },
  { family: "DM Serif Text", category: "serif" },
  { family: "Damion", category: "handwriting" },
  { family: "Dancing Script", category: "handwriting" },
  { family: "Dangrek", category: "display" },
  { family: "Darumadrop One", category: "display" },
  { family: "David Libre", category: "serif" },
  { family: "Dawning of a New Day", category: "handwriting" },
  { family: "Days One", category: "sans-serif" },
  { family: "Dekko", category: "handwriting" },
  { family: "Delius", category: "handwriting" },
  { family: "Delius Swash Caps", category: "handwriting" },
  { family: "Delius Unicase", category: "handwriting" },
  { family: "Della Respira", category: "serif" },
  { family: "Denk One", category: "sans-serif" },
  { family: "Devonshire", category: "handwriting" },
  { family: "Dhurjati", category: "sans-serif" },
  { family: "Didact Gothic", category: "sans-serif" },
  { family: "Diplomata", category: "display" },
  { family: "Diplomata SC", category: "display" },
  { family: "Do Hyeon", category: "sans-serif" },
  { family: "Dokdo", category: "handwriting" },
  { family: "Domine", category: "serif" },
  { family: "Dongle", category: "sans-serif" },
  { family: "Doppio One", category: "sans-serif" },
  { family: "Dorsa", category: "sans-serif" },
  { family: "Dosis", category: "sans-serif" },
  { family: "DotGothic16", category: "sans-serif" },
  { family: "Dr Sugiyama", category: "handwriting" },
  { family: "Duru Sans", category: "sans-serif" },
  { family: "Dynalight", category: "display" },
  // E
  { family: "EB Garamond", category: "serif" },
  { family: "Edu NSW ACT Foundation", category: "handwriting" },
  { family: "Edu QLD Beginner", category: "handwriting" },
  { family: "Edu SA Beginner", category: "handwriting" },
  { family: "Edu TAS Beginner", category: "handwriting" },
  { family: "Edu VIC WA NT Beginner", category: "handwriting" },
  { family: "El Messiri", category: "sans-serif" },
  { family: "Electrolize", category: "sans-serif" },
  { family: "Elsie", category: "display" },
  { family: "Elsie Swash Caps", category: "display" },
  { family: "Emblema One", category: "display" },
  { family: "Emilys Candy", category: "display" },
  { family: "Encode Sans", category: "sans-serif" },
  { family: "Encode Sans Condensed", category: "sans-serif" },
  { family: "Encode Sans Expanded", category: "sans-serif" },
  { family: "Encode Sans SC", category: "sans-serif" },
  { family: "Encode Sans Semi Condensed", category: "sans-serif" },
  { family: "Encode Sans Semi Expanded", category: "sans-serif" },
  { family: "Engagement", category: "handwriting" },
  { family: "Englebert", category: "sans-serif" },
  { family: "Enriqueta", category: "serif" },
  { family: "Ephesis", category: "handwriting" },
  { family: "Epilogue", category: "sans-serif" },
  { family: "Erica One", category: "display" },
  { family: "Esteban", category: "serif" },
  { family: "Estonia", category: "handwriting" },
  { family: "Euphoria Script", category: "handwriting" },
  { family: "Ewert", category: "display" },
  { family: "Exo", category: "sans-serif" },
  { family: "Exo 2", category: "sans-serif" },
  { family: "Expletus Sans", category: "display" },
  { family: "Explora", category: "handwriting" },
  // F
  { family: "Fahkwang", category: "sans-serif" },
  { family: "Familjen Grotesk", category: "sans-serif" },
  { family: "Fanwood Text", category: "serif" },
  { family: "Farro", category: "sans-serif" },
  { family: "Farsan", category: "display" },
  { family: "Fascinate", category: "display" },
  { family: "Fascinate Inline", category: "display" },
  { family: "Faster One", category: "display" },
  { family: "Fasthand", category: "serif" },
  { family: "Fauna One", category: "serif" },
  { family: "Faustina", category: "serif" },
  { family: "Federant", category: "display" },
  { family: "Federo", category: "sans-serif" },
  { family: "Felipa", category: "handwriting" },
  { family: "Fenix", category: "serif" },
  { family: "Festive", category: "handwriting" },
  { family: "Figtree", category: "sans-serif" },
  { family: "Finger Paint", category: "display" },
  { family: "Finlandica", category: "sans-serif" },
  { family: "Fira Code", category: "monospace" },
  { family: "Fira Mono", category: "monospace" },
  { family: "Fira Sans", category: "sans-serif" },
  { family: "Fira Sans Condensed", category: "sans-serif" },
  { family: "Fira Sans Extra Condensed", category: "sans-serif" },
  { family: "Fjalla One", category: "sans-serif" },
  { family: "Fjord One", category: "serif" },
  { family: "Flamenco", category: "display" },
  { family: "Flavors", category: "display" },
  { family: "Fleur De Leah", category: "handwriting" },
  { family: "Flow Block", category: "display" },
  { family: "Flow Circular", category: "display" },
  { family: "Flow Rounded", category: "display" },
  { family: "Fondamento", category: "handwriting" },
  { family: "Fontdiner Swanky", category: "display" },
  { family: "Forum", category: "display" },
  { family: "Fragment Mono", category: "monospace" },
  { family: "Francois One", category: "sans-serif" },
  { family: "Frank Ruhl Libre", category: "serif" },
  { family: "Fraunces", category: "serif" },
  { family: "Freckle Face", category: "display" },
  { family: "Fredericka the Great", category: "display" },
  { family: "Fredoka", category: "sans-serif" },
  { family: "Fredoka One", category: "display" },
  { family: "Freehand", category: "display" },
  { family: "Fresca", category: "sans-serif" },
  { family: "Frijole", category: "display" },
  { family: "Fruktur", category: "display" },
  { family: "Fugaz One", category: "display" },
  { family: "Fuggles", category: "handwriting" },
  { family: "Fuzzy Bubbles", category: "handwriting" },
  // G
  { family: "GFS Didot", category: "serif" },
  { family: "GFS Neohellenic", category: "sans-serif" },
  { family: "Gabriela", category: "serif" },
  { family: "Gaegu", category: "handwriting" },
  { family: "Gafata", category: "sans-serif" },
  { family: "Galindo", category: "display" },
  { family: "Gamja Flower", category: "handwriting" },
  { family: "Gantari", category: "sans-serif" },
  { family: "Gasoek One", category: "sans-serif" },
  { family: "Gelasio", category: "serif" },
  { family: "Gemunu Libre", category: "sans-serif" },
  { family: "Genos", category: "sans-serif" },
  { family: "Gentium Book Plus", category: "serif" },
  { family: "Gentium Plus", category: "serif" },
  { family: "Geo", category: "sans-serif" },
  { family: "Geologica", category: "sans-serif" },
  { family: "Georama", category: "sans-serif" },
  { family: "Gideon Roman", category: "display" },
  { family: "Gidugu", category: "sans-serif" },
  { family: "Gilda Display", category: "serif" },
  { family: "Girassol", category: "display" },
  { family: "Give You Glory", category: "handwriting" },
  { family: "Glass Antiqua", category: "display" },
  { family: "Glegoo", category: "serif" },
  { family: "Gloock", category: "serif" },
  { family: "Gloria Hallelujah", category: "handwriting" },
  { family: "Glory", category: "sans-serif" },
  { family: "Gluten", category: "display" },
  { family: "Goblin One", category: "display" },
  { family: "Gochi Hand", category: "handwriting" },
  { family: "Goldman", category: "display" },
  { family: "Golos Text", category: "sans-serif" },
  { family: "Gorditas", category: "display" },
  { family: "Gothic A1", category: "sans-serif" },
  { family: "Gotu", category: "sans-serif" },
  { family: "Graduate", category: "serif" },
  { family: "Grand Hotel", category: "handwriting" },
  { family: "Grandstander", category: "display" },
  { family: "Grape Nuts", category: "handwriting" },
  { family: "Gravitas One", category: "display" },
  { family: "Great Vibes", category: "handwriting" },
  { family: "Grechen Fuemen", category: "handwriting" },
  { family: "Grenze", category: "display" },
  { family: "Grenze Gotisch", category: "display" },
  { family: "Grey Qo", category: "handwriting" },
  { family: "Griffy", category: "display" },
  { family: "Gruppo", category: "display" },
  { family: "Gudea", category: "sans-serif" },
  { family: "Gugi", category: "display" },
  { family: "Gulzar", category: "serif" },
  { family: "Gupter", category: "serif" },
  { family: "Gurajada", category: "serif" },
  { family: "Gwendolyn", category: "handwriting" },
  { family: "Habibi", category: "serif" },
  // H - I - J - K
  { family: "Hachi Maru Pop", category: "handwriting" },
  { family: "Hahmlet", category: "serif" },
  { family: "Hammersmith One", category: "sans-serif" },
  { family: "Hanalei", category: "display" },
  { family: "Hanalei Fill", category: "display" },
  { family: "Handjet", category: "display" },
  { family: "Hanken Grotesk", category: "sans-serif" },
  { family: "Hanuman", category: "serif" },
  { family: "Happy Monkey", category: "display" },
  { family: "Harmattan", category: "sans-serif" },
  { family: "Headland One", category: "serif" },
  { family: "Hedvig Letters Sans", category: "sans-serif" },
  { family: "Hedvig Letters Serif", category: "serif" },
  { family: "Heebo", category: "sans-serif" },
  { family: "Henny Penny", category: "display" },
  { family: "Hepta Slab", category: "serif" },
  { family: "Herr Von Muellerhoff", category: "handwriting" },
  { family: "Hi Melody", category: "handwriting" },
  { family: "Hina Mincho", category: "serif" },
  { family: "Hind", category: "sans-serif" },
  { family: "Hind Guntur", category: "sans-serif" },
  { family: "Hind Madurai", category: "sans-serif" },
  { family: "Hind Siliguri", category: "sans-serif" },
  { family: "Hind Vadodara", category: "sans-serif" },
  { family: "Holtwood One SC", category: "serif" },
  { family: "Homemade Apple", category: "handwriting" },
  { family: "Homenaje", category: "sans-serif" },
  { family: "Hubballi", category: "sans-serif" },
  { family: "Hyphen Point", category: "sans-serif" },
  { family: "IBM Plex Mono", category: "monospace" },
  { family: "IBM Plex Sans", category: "sans-serif" },
  { family: "IBM Plex Sans Arabic", category: "sans-serif" },
  { family: "IBM Plex Sans Condensed", category: "sans-serif" },
  { family: "IBM Plex Sans Devanagari", category: "sans-serif" },
  { family: "IBM Plex Sans Hebrew", category: "sans-serif" },
  { family: "IBM Plex Sans JP", category: "sans-serif" },
  { family: "IBM Plex Sans KR", category: "sans-serif" },
  { family: "IBM Plex Sans Thai", category: "sans-serif" },
  { family: "IBM Plex Sans Thai Looped", category: "sans-serif" },
  { family: "IBM Plex Serif", category: "serif" },
  { family: "IM Fell DW Pica", category: "serif" },
  { family: "IM Fell Double Pica", category: "serif" },
  { family: "IM Fell English", category: "serif" },
  { family: "IM Fell English SC", category: "serif" },
  { family: "IM Fell French Canon", category: "serif" },
  { family: "IM Fell French Canon SC", category: "serif" },
  { family: "IM Fell Great Primer", category: "serif" },
  { family: "IM Fell Great Primer SC", category: "serif" },
  { family: "Ibarra Real Nova", category: "serif" },
  { family: "Iceland", category: "display" },
  { family: "Imbue", category: "serif" },
  { family: "Imperial Script", category: "handwriting" },
  { family: "Imprima", category: "sans-serif" },
  { family: "Inconsolata", category: "monospace" },
  { family: "Inder", category: "sans-serif" },
  { family: "Indie Flower", category: "handwriting" },
  { family: "Ingrid Darling", category: "handwriting" },
  { family: "Inika", category: "serif" },
  { family: "Inknut Antiqua", category: "serif" },
  { family: "Inria Sans", category: "sans-serif" },
  { family: "Inria Serif", category: "serif" },
  { family: "Inspiration", category: "handwriting" },
  { family: "Instrument Sans", category: "sans-serif" },
  { family: "Instrument Serif", category: "serif" },
  { family: "Inter", category: "sans-serif" },
  { family: "Inter Tight", category: "sans-serif" },
  { family: "Irish Grover", category: "display" },
  { family: "Island Moments", category: "handwriting" },
  { family: "Istok Web", category: "sans-serif" },
  { family: "Italiana", category: "serif" },
  { family: "Italianno", category: "handwriting" },
  { family: "Itim", category: "handwriting" },
  { family: "Jacques Francois", category: "serif" },
  { family: "Jacques Francois Shadow", category: "display" },
  { family: "Jaldi", category: "sans-serif" },
  { family: "JetBrains Mono", category: "monospace" },
  { family: "Jim Nightshade", category: "handwriting" },
  { family: "Joan", category: "serif" },
  { family: "Jockey One", category: "sans-serif" },
  { family: "Jolly Lodger", category: "display" },
  { family: "Jomhuria", category: "display" },
  { family: "Jomolhari", category: "serif" },
  { family: "Josefin Sans", category: "sans-serif" },
  { family: "Josefin Slab", category: "serif" },
  { family: "Jost", category: "sans-serif" },
  { family: "Joti One", category: "display" },
  { family: "Jua", category: "sans-serif" },
  { family: "Judson", category: "serif" },
  { family: "Julee", category: "display" },
  { family: "Julius Sans One", category: "sans-serif" },
  { family: "Junge", category: "serif" },
  { family: "Jura", category: "sans-serif" },
  { family: "Just Another Hand", category: "handwriting" },
  { family: "Just Me Again Down Here", category: "handwriting" },
  { family: "K2D", category: "sans-serif" },
  { family: "Kablammo", category: "display" },
  { family: "Kadwa", category: "serif" },
  { family: "Kaisei Decol", category: "serif" },
  { family: "Kaisei HarunoUmi", category: "serif" },
  { family: "Kaisei Opti", category: "serif" },
  { family: "Kaisei Tokumin", category: "serif" },
  { family: "Kalam", category: "handwriting" },
  { family: "Karma", category: "serif" },
  { family: "Katibeh", category: "display" },
  { family: "Kaushan Script", category: "handwriting" },
  { family: "Kavivanar", category: "handwriting" },
  { family: "Kavoon", category: "display" },
  { family: "Kay Pho Du", category: "sans-serif" },
  { family: "Kdam Thmor Pro", category: "sans-serif" },
  { family: "Keania One", category: "display" },
  { family: "Kelly Slab", category: "display" },
  { family: "Kenia", category: "display" },
  { family: "Klee One", category: "handwriting" },
  { family: "Knewave", category: "display" },
  { family: "KoHo", category: "sans-serif" },
  { family: "Kodchasan", category: "sans-serif" },
  { family: "Koh Santepheap", category: "display" },
  { family: "Kolker Brush", category: "handwriting" },
  { family: "Konkhmer Sleokchher", category: "display" },
  { family: "Kosugi", category: "sans-serif" },
  { family: "Kosugi Maru", category: "sans-serif" },
  { family: "Kotta One", category: "serif" },
  { family: "Kranky", category: "display" },
  { family: "Kreon", category: "serif" },
  { family: "Kristi", category: "handwriting" },
  { family: "Krona One", category: "sans-serif" },
  { family: "Krub", category: "sans-serif" },
  { family: "Kufam", category: "sans-serif" },
  { family: "Kulim Park", category: "sans-serif" },
  { family: "Kumar One", category: "display" },
  { family: "Kumar One Outline", category: "display" },
  { family: "Kumbh Sans", category: "sans-serif" },
  { family: "Kurale", category: "serif" },
  // L
  { family: "La Belle Aurore", category: "handwriting" },
  { family: "Labrada", category: "serif" },
  { family: "Lacquer", category: "display" },
  { family: "Laila", category: "serif" },
  { family: "Lakki Reddy", category: "handwriting" },
  { family: "Lalezar", category: "display" },
  { family: "Lancelot", category: "display" },
  { family: "Langar", category: "display" },
  { family: "Lateef", category: "serif" },
  { family: "Lato", category: "sans-serif" },
  { family: "Lavishly Yours", category: "handwriting" },
  { family: "League Gothic", category: "sans-serif" },
  { family: "League Script", category: "handwriting" },
  { family: "League Spartan", category: "sans-serif" },
  { family: "Leckerli One", category: "handwriting" },
  { family: "Ledger", category: "serif" },
  { family: "Lekton", category: "sans-serif" },
  { family: "Lemon", category: "display" },
  { family: "Lemonada", category: "display" },
  { family: "Lexend", category: "sans-serif" },
  { family: "Lexend Deca", category: "sans-serif" },
  { family: "Lexend Exa", category: "sans-serif" },
  { family: "Lexend Giga", category: "sans-serif" },
  { family: "Lexend Mega", category: "sans-serif" },
  { family: "Lexend Peta", category: "sans-serif" },
  { family: "Lexend Tera", category: "sans-serif" },
  { family: "Lexend Zetta", category: "sans-serif" },
  { family: "Libre Barcode 128", category: "display" },
  { family: "Libre Barcode 128 Text", category: "display" },
  { family: "Libre Barcode 39", category: "display" },
  { family: "Libre Barcode 39 Extended", category: "display" },
  { family: "Libre Barcode 39 Extended Text", category: "display" },
  { family: "Libre Barcode 39 Text", category: "display" },
  { family: "Libre Barcode EAN13 Text", category: "display" },
  { family: "Libre Baskerville", category: "serif" },
  { family: "Libre Bodoni", category: "serif" },
  { family: "Libre Caslon Display", category: "serif" },
  { family: "Libre Caslon Text", category: "serif" },
  { family: "Libre Franklin", category: "sans-serif" },
  { family: "Licorice", category: "handwriting" },
  { family: "Life Savers", category: "display" },
  { family: "Lilita One", category: "display" },
  { family: "Lily Script One", category: "display" },
  { family: "Limelight", category: "display" },
  { family: "Linden Hill", category: "serif" },
  { family: "Lisu Bosa", category: "serif" },
  { family: "Literata", category: "serif" },
  { family: "Liu Jian Mao Cao", category: "handwriting" },
  { family: "Livvic", category: "sans-serif" },
  { family: "Lobster", category: "display" },
  { family: "Lobster Two", category: "display" },
  { family: "Londrina Outline", category: "display" },
  { family: "Londrina Shadow", category: "display" },
  { family: "Londrina Sketch", category: "display" },
  { family: "Londrina Solid", category: "display" },
  { family: "Long Cang", category: "handwriting" },
  { family: "Lora", category: "serif" },
  { family: "Love Light", category: "handwriting" },
  { family: "Love Ya Like A Sister", category: "display" },
  { family: "Loved by the King", category: "handwriting" },
  { family: "Lovers Quarrel", category: "handwriting" },
  { family: "Luckiest Guy", category: "display" },
  { family: "Lugrasimo", category: "handwriting" },
  { family: "Lumanosimo", category: "handwriting" },
  { family: "Lunasima", category: "sans-serif" },
  { family: "Lusitana", category: "serif" },
  { family: "Lustria", category: "serif" },
  { family: "Luxurious Roman", category: "display" },
  { family: "Luxurious Script", category: "handwriting" },
  // M
  { family: "M PLUS 1", category: "sans-serif" },
  { family: "M PLUS 1 Code", category: "monospace" },
  { family: "M PLUS 1p", category: "sans-serif" },
  { family: "M PLUS 2", category: "sans-serif" },
  { family: "M PLUS Code Latin", category: "monospace" },
  { family: "M PLUS Rounded 1c", category: "sans-serif" },
  { family: "Ma Shan Zheng", category: "handwriting" },
  { family: "Macondo", category: "display" },
  { family: "Macondo Swash Caps", category: "display" },
  { family: "Mada", category: "sans-serif" },
  { family: "Madimi One", category: "sans-serif" },
  { family: "Magra", category: "sans-serif" },
  { family: "Maiden Orange", category: "display" },
  { family: "Maitree", category: "serif" },
  { family: "Major Mono Display", category: "monospace" },
  { family: "Mako", category: "sans-serif" },
  { family: "Mali", category: "handwriting" },
  { family: "Mallanna", category: "sans-serif" },
  { family: "Mandali", category: "sans-serif" },
  { family: "Manjari", category: "sans-serif" },
  { family: "Manrope", category: "sans-serif" },
  { family: "Mansalva", category: "display" },
  { family: "Marcellus", category: "serif" },
  { family: "Marcellus SC", category: "serif" },
  { family: "Marck Script", category: "handwriting" },
  { family: "Margarine", category: "display" },
  { family: "Marhey", category: "display" },
  { family: "Markazi Text", category: "serif" },
  { family: "Marko One", category: "serif" },
  { family: "Marmelad", category: "sans-serif" },
  { family: "Martel", category: "serif" },
  { family: "Martel Sans", category: "sans-serif" },
  { family: "Marvel", category: "sans-serif" },
  { family: "Mate", category: "serif" },
  { family: "Mate SC", category: "serif" },
  { family: "Maven Pro", category: "sans-serif" },
  { family: "McLaren", category: "display" },
  { family: "Mea Culpa", category: "handwriting" },
  { family: "Meddon", category: "handwriting" },
  { family: "MedievalSharp", category: "display" },
  { family: "Medula One", category: "display" },
  { family: "Meera Inimai", category: "sans-serif" },
  { family: "Megrim", category: "display" },
  { family: "Meie Script", category: "handwriting" },
  { family: "Meow Script", category: "handwriting" },
  { family: "Merienda", category: "handwriting" },
  { family: "Merriweather", category: "serif" },
  { family: "Merriweather Sans", category: "sans-serif" },
  { family: "Metal", category: "display" },
  { family: "Metal Mania", category: "display" },
  { family: "Metamorphous", category: "display" },
  { family: "Metrophobic", category: "sans-serif" },
  { family: "Michroma", category: "sans-serif" },
  { family: "Miedingers Schrift", category: "sans-serif" },
  { family: "Milonga", category: "display" },
  { family: "Miltonian", category: "display" },
  { family: "Miltonian Tattoo", category: "display" },
  { family: "Mina", category: "sans-serif" },
  { family: "Mingzat", category: "sans-serif" },
  { family: "Miniver", category: "display" },
  { family: "Miriam Libre", category: "sans-serif" },
  { family: "Mirza", category: "serif" },
  { family: "Miss Fajardose", category: "handwriting" },
  { family: "Mitr", category: "sans-serif" },
  { family: "Mochiy Pop One", category: "sans-serif" },
  { family: "Mochiy Pop P One", category: "sans-serif" },
  { family: "Modak", category: "display" },
  { family: "Modern Antiqua", category: "display" },
  { family: "Mogra", category: "display" },
  { family: "Mohave", category: "sans-serif" },
  { family: "Moirai One", category: "display" },
  { family: "Molengo", category: "sans-serif" },
  { family: "Molle", category: "handwriting" },
  { family: "Monda", category: "sans-serif" },
  { family: "Monofett", category: "display" },
  { family: "Monomaniac One", category: "sans-serif" },
  { family: "Monoton", category: "display" },
  { family: "Monsieur La Doulaise", category: "handwriting" },
  { family: "Montaga", category: "serif" },
  { family: "Montagu Slab", category: "serif" },
  { family: "MonteCarlo", category: "handwriting" },
  { family: "Montez", category: "handwriting" },
  { family: "Montserrat", category: "sans-serif" },
  { family: "Montserrat Alternates", category: "sans-serif" },
  { family: "Montserrat Subrayada", category: "sans-serif" },
  { family: "Moo Lah Lah", category: "display" },
  { family: "Moon Dance", category: "handwriting" },
  { family: "Moul", category: "display" },
  { family: "Moulpali", category: "sans-serif" },
  { family: "Mountains of Christmas", category: "display" },
  { family: "Mouse Memoirs", category: "sans-serif" },
  { family: "Mr Bedfort", category: "handwriting" },
  { family: "Mr Dafoe", category: "handwriting" },
  { family: "Mr De Haviland", category: "handwriting" },
  { family: "Mrs Saint Delafield", category: "handwriting" },
  { family: "Mrs Sheppards", category: "handwriting" },
  { family: "Ms Madi", category: "handwriting" },
  { family: "Mukta", category: "sans-serif" },
  { family: "Mukta Mahee", category: "sans-serif" },
  { family: "Mukta Malar", category: "sans-serif" },
  { family: "Mukta Vaani", category: "sans-serif" },
  { family: "Mulish", category: "sans-serif" },
  { family: "Murecho", category: "sans-serif" },
  { family: "MuseoModerno", category: "display" },
  { family: "My Soul", category: "handwriting" },
  { family: "Mynerve", category: "handwriting" },
  { family: "Mystery Quest", category: "display" },
  // N
  { family: "NTR", category: "sans-serif" },
  { family: "Nabla", category: "display" },
  { family: "Namdhinggo", category: "serif" },
  { family: "Nanum Brush Script", category: "handwriting" },
  { family: "Nanum Gothic", category: "sans-serif" },
  { family: "Nanum Gothic Coding", category: "monospace" },
  { family: "Nanum Myeongjo", category: "serif" },
  { family: "Nanum Pen Script", category: "handwriting" },
  { family: "Narnoor", category: "serif" },
  { family: "Neonderthaw", category: "handwriting" },
  { family: "Nerko One", category: "handwriting" },
  { family: "Neucha", category: "handwriting" },
  { family: "Neuton", category: "serif" },
  { family: "New Rocker", category: "display" },
  { family: "New Tegomin", category: "serif" },
  { family: "News Cycle", category: "sans-serif" },
  { family: "Newsreader", category: "serif" },
  { family: "Niconne", category: "handwriting" },
  { family: "Niramit", category: "sans-serif" },
  { family: "Nixie One", category: "display" },
  { family: "Nobile", category: "sans-serif" },
  { family: "Nokora", category: "sans-serif" },
  { family: "Norican", category: "handwriting" },
  { family: "Nosifer", category: "display" },
  { family: "Nothing You Could Do", category: "handwriting" },
  { family: "Noticia Text", category: "serif" },
  { family: "Noto Color Emoji", category: "sans-serif" },
  { family: "Noto Emoji", category: "sans-serif" },
  { family: "Noto Kufi Arabic", category: "sans-serif" },
  { family: "Noto Music", category: "sans-serif" },
  { family: "Noto Naskh Arabic", category: "serif" },
  { family: "Noto Nastaliq Urdu", category: "serif" },
  { family: "Noto Rashi Hebrew", category: "serif" },
  { family: "Noto Sans", category: "sans-serif" },
  { family: "Noto Sans Adlam", category: "sans-serif" },
  { family: "Noto Sans Arabic", category: "sans-serif" },
  { family: "Noto Sans Armenian", category: "sans-serif" },
  { family: "Noto Sans Bengali", category: "sans-serif" },
  { family: "Noto Sans Cherokee", category: "sans-serif" },
  { family: "Noto Sans Devanagari", category: "sans-serif" },
  { family: "Noto Sans Display", category: "sans-serif" },
  { family: "Noto Sans Ethiopic", category: "sans-serif" },
  { family: "Noto Sans Georgian", category: "sans-serif" },
  { family: "Noto Sans Gujarati", category: "sans-serif" },
  { family: "Noto Sans Gurmukhi", category: "sans-serif" },
  { family: "Noto Sans HK", category: "sans-serif" },
  { family: "Noto Sans Hebrew", category: "sans-serif" },
  { family: "Noto Sans JP", category: "sans-serif" },
  { family: "Noto Sans KR", category: "sans-serif" },
  { family: "Noto Sans Kannada", category: "sans-serif" },
  { family: "Noto Sans Khmer", category: "sans-serif" },
  { family: "Noto Sans Lao", category: "sans-serif" },
  { family: "Noto Sans Malayalam", category: "sans-serif" },
  { family: "Noto Sans Mandaic", category: "sans-serif" },
  { family: "Noto Sans Math", category: "sans-serif" },
  { family: "Noto Sans Mono", category: "monospace" },
  { family: "Noto Sans Myanmar", category: "sans-serif" },
  { family: "Noto Sans Oriya", category: "sans-serif" },
  { family: "Noto Sans SC", category: "sans-serif" },
  { family: "Noto Sans Sinhala", category: "sans-serif" },
  { family: "Noto Sans Syriac", category: "sans-serif" },
  { family: "Noto Sans TC", category: "sans-serif" },
  { family: "Noto Sans Tamil", category: "sans-serif" },
  { family: "Noto Sans Telugu", category: "sans-serif" },
  { family: "Noto Sans Thai", category: "sans-serif" },
  { family: "Noto Sans Thai Looped", category: "sans-serif" },
  { family: "Noto Sans Tibetan", category: "sans-serif" },
  { family: "Noto Serif", category: "serif" },
  { family: "Noto Serif Armenian", category: "serif" },
  { family: "Noto Serif Bengali", category: "serif" },
  { family: "Noto Serif Devanagari", category: "serif" },
  { family: "Noto Serif Display", category: "serif" },
  { family: "Noto Serif Ethiopic", category: "serif" },
  { family: "Noto Serif Georgian", category: "serif" },
  { family: "Noto Serif Gujarati", category: "serif" },
  { family: "Noto Serif Gurmukhi", category: "serif" },
  { family: "Noto Serif HK", category: "serif" },
  { family: "Noto Serif Hebrew", category: "serif" },
  { family: "Noto Serif JP", category: "serif" },
  { family: "Noto Serif KR", category: "serif" },
  { family: "Noto Serif Kannada", category: "serif" },
  { family: "Noto Serif Khmer", category: "serif" },
  { family: "Noto Serif Lao", category: "serif" },
  { family: "Noto Serif Malayalam", category: "serif" },
  { family: "Noto Serif Myanmar", category: "serif" },
  { family: "Noto Serif Oriya", category: "serif" },
  { family: "Noto Serif SC", category: "serif" },
  { family: "Noto Serif Sinhala", category: "serif" },
  { family: "Noto Serif TC", category: "serif" },
  { family: "Noto Serif Tamil", category: "serif" },
  { family: "Noto Serif Telugu", category: "serif" },
  { family: "Noto Serif Thai", category: "serif" },
  { family: "Noto Serif Tibetan", category: "serif" },
  { family: "Nova Cut", category: "display" },
  { family: "Nova Flat", category: "display" },
  { family: "Nova Mono", category: "monospace" },
  { family: "Nova Oval", category: "display" },
  { family: "Nova Round", category: "display" },
  { family: "Nova Script", category: "display" },
  { family: "Nova Slim", category: "display" },
  { family: "Nova Square", category: "display" },
  { family: "Numans", category: "sans-serif" },
  { family: "Nunito", category: "sans-serif" },
  { family: "Nunito Sans", category: "sans-serif" },
  // O - P - Q - R
  { family: "Ojuju", category: "sans-serif" },
  { family: "Old Standard TT", category: "serif" },
  { family: "Oldenburg", category: "display" },
  { family: "Ole", category: "handwriting" },
  { family: "Oleo Script", category: "display" },
  { family: "Oleo Script Swash Caps", category: "display" },
  { family: "Onest", category: "sans-serif" },
  { family: "Open Sans", category: "sans-serif" },
  { family: "Oranienbaum", category: "serif" },
  { family: "Orbit", category: "sans-serif" },
  { family: "Orbitron", category: "sans-serif" },
  { family: "Oregano", category: "display" },
  { family: "Orelega One", category: "display" },
  { family: "Orienta", category: "sans-serif" },
  { family: "Original Surfer", category: "display" },
  { family: "Oswald", category: "sans-serif" },
  { family: "Outfit", category: "sans-serif" },
  { family: "Over the Rainbow", category: "handwriting" },
  { family: "Overlock", category: "display" },
  { family: "Overlock SC", category: "display" },
  { family: "Overpass", category: "sans-serif" },
  { family: "Overpass Mono", category: "monospace" },
  { family: "Ovo", category: "serif" },
  { family: "Oxanium", category: "display" },
  { family: "Oxygen", category: "sans-serif" },
  { family: "Oxygen Mono", category: "monospace" },
  { family: "PT Mono", category: "monospace" },
  { family: "PT Sans", category: "sans-serif" },
  { family: "PT Sans Caption", category: "sans-serif" },
  { family: "PT Sans Narrow", category: "sans-serif" },
  { family: "PT Serif", category: "serif" },
  { family: "PT Serif Caption", category: "serif" },
  { family: "Pacifico", category: "handwriting" },
  { family: "Padauk", category: "sans-serif" },
  { family: "Padyakke Expanded One", category: "serif" },
  { family: "Palanquin", category: "sans-serif" },
  { family: "Palanquin Dark", category: "sans-serif" },
  { family: "Palette Mosaic", category: "display" },
  { family: "Pangolin", category: "handwriting" },
  { family: "Paprika", category: "display" },
  { family: "Parisienne", category: "handwriting" },
  { family: "Passero One", category: "display" },
  { family: "Passion One", category: "display" },
  { family: "Passions Conflict", category: "handwriting" },
  { family: "Pathway Extreme", category: "sans-serif" },
  { family: "Pathway Gothic One", category: "sans-serif" },
  { family: "Patrick Hand", category: "handwriting" },
  { family: "Patrick Hand SC", category: "handwriting" },
  { family: "Pattaya", category: "sans-serif" },
  { family: "Patua One", category: "display" },
  { family: "Pavanam", category: "sans-serif" },
  { family: "Paytone One", category: "sans-serif" },
  { family: "Peddana", category: "serif" },
  { family: "Peralta", category: "display" },
  { family: "Permanent Marker", category: "handwriting" },
  { family: "Petemoss", category: "handwriting" },
  { family: "Petit Formal Script", category: "handwriting" },
  { family: "Petrona", category: "serif" },
  { family: "Philosopher", category: "serif" },
  { family: "Piazzolla", category: "serif" },
  { family: "Piedra", category: "display" },
  { family: "Pinyon Script", category: "handwriting" },
  { family: "Pirata One", category: "display" },
  { family: "Pixelify Sans", category: "display" },
  { family: "Plaster", category: "display" },
  { family: "Platypi", category: "serif" },
  { family: "Play", category: "sans-serif" },
  { family: "Playball", category: "display" },
  { family: "Playfair Display", category: "serif" },
  { family: "Playfair Display SC", category: "serif" },
  { family: "Playpen Sans", category: "handwriting" },
  { family: "Plus Jakarta Sans", category: "sans-serif" },
  { family: "Podkova", category: "serif" },
  { family: "Poiret One", category: "display" },
  { family: "Poller One", category: "display" },
  { family: "Poltawski Nowy", category: "serif" },
  { family: "Poly", category: "serif" },
  { family: "Pompiere", category: "display" },
  { family: "Pontano Sans", category: "sans-serif" },
  { family: "Poor Story", category: "display" },
  { family: "Poppins", category: "sans-serif" },
  { family: "Port Lligat Sans", category: "sans-serif" },
  { family: "Port Lligat Slab", category: "serif" },
  { family: "Prata", category: "serif" },
  { family: "Preahvihear", category: "display" },
  { family: "Press Start 2P", category: "display" },
  { family: "Pridi", category: "serif" },
  { family: "Princess Sofia", category: "handwriting" },
  { family: "Prociono", category: "serif" },
  { family: "Prompt", category: "sans-serif" },
  { family: "Prosto One", category: "display" },
  { family: "Proza Libre", category: "sans-serif" },
  { family: "Public Sans", category: "sans-serif" },
  { family: "Puppies Play", category: "handwriting" },
  { family: "Puritan", category: "sans-serif" },
  { family: "Purple Purse", category: "display" },
  { family: "Qahiri", category: "sans-serif" },
  { family: "Quando", category: "serif" },
  { family: "Quantico", category: "sans-serif" },
  { family: "Quattrocento", category: "serif" },
  { family: "Quattrocento Sans", category: "sans-serif" },
  { family: "Questrial", category: "sans-serif" },
  { family: "Quicksand", category: "sans-serif" },
  { family: "Quintessential", category: "handwriting" },
  { family: "Qwigley", category: "handwriting" },
  { family: "Qwitcher Grypen", category: "handwriting" },
  { family: "Racing Sans One", category: "display" },
  { family: "Radio Canada", category: "sans-serif" },
  { family: "Radio Canada Big", category: "sans-serif" },
  { family: "Radley", category: "serif" },
  { family: "Rajdhani", category: "sans-serif" },
  { family: "Rakkas", category: "display" },
  { family: "Raleway", category: "sans-serif" },
  { family: "Raleway Dots", category: "display" },
  { family: "Ramabhadra", category: "sans-serif" },
  { family: "Ramaraja", category: "serif" },
  { family: "Rambla", category: "sans-serif" },
  { family: "Rammetto One", category: "display" },
  { family: "Rampart One", category: "display" },
  { family: "Ranchers", category: "display" },
  { family: "Rancho", category: "handwriting" },
  { family: "Ranga", category: "display" },
  { family: "Rasa", category: "serif" },
  { family: "Rationale", category: "sans-serif" },
  { family: "Ravi Prakash", category: "display" },
  { family: "Readex Pro", category: "sans-serif" },
  { family: "Recursive", category: "sans-serif" },
  { family: "Red Hat Display", category: "sans-serif" },
  { family: "Red Hat Mono", category: "monospace" },
  { family: "Red Hat Text", category: "sans-serif" },
  { family: "Red Rose", category: "display" },
  { family: "Redacted", category: "display" },
  { family: "Redacted Script", category: "handwriting" },
  { family: "Reem Kufi", category: "sans-serif" },
  { family: "Reem Kufi Fun", category: "sans-serif" },
  { family: "Reem Kufi Ink", category: "sans-serif" },
  { family: "Reenie Beanie", category: "handwriting" },
  { family: "Reggae One", category: "display" },
  { family: "Rethink Sans", category: "sans-serif" },
  { family: "Revalia", category: "display" },
  { family: "Rhodium Libre", category: "serif" },
  { family: "Ribeye", category: "display" },
  { family: "Ribeye Marrow", category: "display" },
  { family: "Righteous", category: "display" },
  { family: "Risque", category: "display" },
  { family: "Road Rage", category: "display" },
  { family: "Roboto", category: "sans-serif" },
  { family: "Roboto Condensed", category: "sans-serif" },
  { family: "Roboto Flex", category: "sans-serif" },
  { family: "Roboto Mono", category: "monospace" },
  { family: "Roboto Serif", category: "serif" },
  { family: "Roboto Slab", category: "serif" },
  { family: "Rochester", category: "handwriting" },
  { family: "Rock 3D", category: "display" },
  { family: "Rock Salt", category: "handwriting" },
  { family: "RocknRoll One", category: "sans-serif" },
  { family: "Rokkitt", category: "serif" },
  { family: "Romanesco", category: "handwriting" },
  { family: "Ropa Sans", category: "sans-serif" },
  { family: "Rosario", category: "sans-serif" },
  { family: "Rosarivo", category: "serif" },
  { family: "Rouge Script", category: "handwriting" },
  { family: "Rowdies", category: "display" },
  { family: "Rozha One", category: "serif" },
  { family: "Rubik", category: "sans-serif" },
  { family: "Rubik 80s Fade", category: "display" },
  { family: "Rubik Beastly", category: "display" },
  { family: "Rubik Broken Fax", category: "display" },
  { family: "Rubik Bubbles", category: "display" },
  { family: "Rubik Burned", category: "display" },
  { family: "Rubik Dirt", category: "display" },
  { family: "Rubik Distressed", category: "display" },
  { family: "Rubik Doodle Shadow", category: "display" },
  { family: "Rubik Doodle Triangles", category: "display" },
  { family: "Rubik Gemstones", category: "display" },
  { family: "Rubik Glitch", category: "display" },
  { family: "Rubik Glitch Pop", category: "display" },
  { family: "Rubik Iso", category: "display" },
  { family: "Rubik Lines", category: "display" },
  { family: "Rubik Maps", category: "display" },
  { family: "Rubik Maze", category: "display" },
  { family: "Rubik Microbe", category: "display" },
  { family: "Rubik Mono One", category: "sans-serif" },
  { family: "Rubik Moonrocks", category: "display" },
  { family: "Rubik One", category: "sans-serif" },
  { family: "Rubik Pixels", category: "display" },
  { family: "Rubik Puddles", category: "display" },
  { family: "Rubik Scribble", category: "display" },
  { family: "Rubik Spray Paint", category: "display" },
  { family: "Rubik Storm", category: "display" },
  { family: "Rubik Vinyl", category: "display" },
  { family: "Rubik Wet Paint", category: "display" },
  { family: "Ruda", category: "sans-serif" },
  { family: "Rufina", category: "serif" },
  { family: "Ruge Boogie", category: "handwriting" },
  { family: "Ruluko", category: "sans-serif" },
  { family: "Rum Raisin", category: "sans-serif" },
  { family: "Ruslan Display", category: "display" },
  { family: "Russo One", category: "sans-serif" },
  { family: "Ruthie", category: "handwriting" },
  { family: "Rye", category: "display" },
  // S
  { family: "STIX Two Text", category: "serif" },
  { family: "Sacramento", category: "handwriting" },
  { family: "Sahitya", category: "serif" },
  { family: "Sail", category: "display" },
  { family: "Saira", category: "sans-serif" },
  { family: "Saira Condensed", category: "sans-serif" },
  { family: "Saira Extra Condensed", category: "sans-serif" },
  { family: "Saira Semi Condensed", category: "sans-serif" },
  { family: "Saira Stencil One", category: "display" },
  { family: "Salsa", category: "display" },
  { family: "Sanchez", category: "serif" },
  { family: "Sancreek", category: "display" },
  { family: "Sansita", category: "sans-serif" },
  { family: "Sansita Swashed", category: "display" },
  { family: "Sarabun", category: "sans-serif" },
  { family: "Sarala", category: "sans-serif" },
  { family: "Sarina", category: "display" },
  { family: "Sarpanch", category: "sans-serif" },
  { family: "Sassy Frass", category: "handwriting" },
  { family: "Satisfy", category: "handwriting" },
  { family: "Sawarabi Gothic", category: "sans-serif" },
  { family: "Sawarabi Mincho", category: "serif" },
  { family: "Scada", category: "sans-serif" },
  { family: "Scheherazade New", category: "serif" },
  { family: "Schibsted Grotesk", category: "sans-serif" },
  { family: "Schoolbell", category: "handwriting" },
  { family: "Scope One", category: "serif" },
  { family: "Seaweed Script", category: "display" },
  { family: "Secular One", category: "sans-serif" },
  { family: "Sedgwick Ave", category: "handwriting" },
  { family: "Sedgwick Ave Display", category: "handwriting" },
  { family: "Sen", category: "sans-serif" },
  { family: "Send Flowers", category: "handwriting" },
  { family: "Sevillana", category: "display" },
  { family: "Seymour One", category: "sans-serif" },
  { family: "Shadows Into Light", category: "handwriting" },
  { family: "Shadows Into Light Two", category: "handwriting" },
  { family: "Shalimar", category: "handwriting" },
  { family: "Shantell Sans", category: "display" },
  { family: "Shanti", category: "sans-serif" },
  { family: "Share", category: "sans-serif" },
  { family: "Share Tech", category: "sans-serif" },
  { family: "Share Tech Mono", category: "monospace" },
  { family: "Shippori Antique", category: "sans-serif" },
  { family: "Shippori Antique B1", category: "sans-serif" },
  { family: "Shippori Mincho", category: "serif" },
  { family: "Shippori Mincho B1", category: "serif" },
  { family: "Shizuru", category: "display" },
  { family: "Shrikhand", category: "display" },
  { family: "Siemreap", category: "display" },
  { family: "Sigmar", category: "display" },
  { family: "Sigmar One", category: "display" },
  { family: "Signika", category: "sans-serif" },
  { family: "Signika Negative", category: "sans-serif" },
  { family: "Silkscreen", category: "display" },
  { family: "Simonetta", category: "display" },
  { family: "Single Day", category: "display" },
  { family: "Sintony", category: "sans-serif" },
  { family: "Sirin Stencil", category: "display" },
  { family: "Six Caps", category: "sans-serif" },
  { family: "Sixtyfour", category: "monospace" },
  { family: "Skranji", category: "display" },
  { family: "Slabo 13px", category: "serif" },
  { family: "Slabo 27px", category: "serif" },
  { family: "Slackey", category: "display" },
  { family: "Slackside One", category: "handwriting" },
  { family: "Smokum", category: "display" },
  { family: "Smooch", category: "handwriting" },
  { family: "Smooch Sans", category: "sans-serif" },
  { family: "Smythe", category: "display" },
  { family: "Sniglet", category: "display" },
  { family: "Snippet", category: "sans-serif" },
  { family: "Snowburst One", category: "display" },
  { family: "Sofadi One", category: "display" },
  { family: "Sofia", category: "handwriting" },
  { family: "Sofia Sans", category: "sans-serif" },
  { family: "Sofia Sans Condensed", category: "sans-serif" },
  { family: "Sofia Sans Extra Condensed", category: "sans-serif" },
  { family: "Sofia Sans Semi Condensed", category: "sans-serif" },
  { family: "Solitreo", category: "handwriting" },
  { family: "Solway", category: "serif" },
  { family: "Song Myung", category: "serif" },
  { family: "Sono", category: "monospace" },
  { family: "Sonsie One", category: "display" },
  { family: "Sora", category: "sans-serif" },
  { family: "Sorts Mill Goudy", category: "serif" },
  { family: "Source Code Pro", category: "monospace" },
  { family: "Source Sans 3", category: "sans-serif" },
  { family: "Source Serif 4", category: "serif" },
  { family: "Space Grotesk", category: "sans-serif" },
  { family: "Space Mono", category: "monospace" },
  { family: "Special Elite", category: "display" },
  { family: "Spectral", category: "serif" },
  { family: "Spectral SC", category: "serif" },
  { family: "Spicy Rice", category: "display" },
  { family: "Spinnaker", category: "sans-serif" },
  { family: "Spirax", category: "display" },
  { family: "Splash", category: "handwriting" },
  { family: "Spline Sans", category: "sans-serif" },
  { family: "Spline Sans Mono", category: "monospace" },
  { family: "Squada One", category: "display" },
  { family: "Square Peg", category: "handwriting" },
  { family: "Sree Krushnadevaraya", category: "serif" },
  { family: "Sriracha", category: "handwriting" },
  { family: "Srisakdi", category: "display" },
  { family: "Staatliches", category: "display" },
  { family: "Stardos Stencil", category: "display" },
  { family: "Stick", category: "sans-serif" },
  { family: "Stick No Bills", category: "sans-serif" },
  { family: "Stint Ultra Condensed", category: "display" },
  { family: "Stint Ultra Expanded", category: "display" },
  { family: "Stoke", category: "serif" },
  { family: "Strait", category: "sans-serif" },
  { family: "Style Script", category: "handwriting" },
  { family: "Stylish", category: "sans-serif" },
  { family: "Sue Ellen Francisco", category: "handwriting" },
  { family: "Suez One", category: "serif" },
  { family: "Sulphur Point", category: "sans-serif" },
  { family: "Sumana", category: "serif" },
  { family: "Sunflower", category: "sans-serif" },
  { family: "Sunshiney", category: "handwriting" },
  { family: "Supermercado One", category: "display" },
  { family: "Sura", category: "serif" },
  { family: "Suranna", category: "serif" },
  { family: "Suravaram", category: "serif" },
  { family: "Suwannaphum", category: "serif" },
  { family: "Swanky and Moo Moo", category: "handwriting" },
  { family: "Syncopate", category: "sans-serif" },
  { family: "Syne", category: "sans-serif" },
  { family: "Syne Mono", category: "monospace" },
  { family: "Syne Tactile", category: "display" },
  // T - U - V - W - X - Y - Z
  { family: "Tai Heritage Pro", category: "serif" },
  { family: "Tajawal", category: "sans-serif" },
  { family: "Tangerine", category: "handwriting" },
  { family: "Tapestry", category: "handwriting" },
  { family: "Taprom", category: "display" },
  { family: "Tauri", category: "sans-serif" },
  { family: "Taviraj", category: "serif" },
  { family: "Teachers", category: "sans-serif" },
  { family: "Teko", category: "sans-serif" },
  { family: "Tektur", category: "display" },
  { family: "Telex", category: "sans-serif" },
  { family: "Tenali Ramakrishna", category: "sans-serif" },
  { family: "Tenor Sans", category: "sans-serif" },
  { family: "Text Me One", category: "sans-serif" },
  { family: "Thasadith", category: "sans-serif" },
  { family: "The Girl Next Door", category: "handwriting" },
  { family: "The Nautigal", category: "handwriting" },
  { family: "Tienne", category: "serif" },
  { family: "Tillana", category: "display" },
  { family: "Tilt Neon", category: "display" },
  { family: "Tilt Prism", category: "display" },
  { family: "Tilt Warp", category: "display" },
  { family: "Timmana", category: "sans-serif" },
  { family: "Tinos", category: "serif" },
  { family: "Tiro Bangla", category: "serif" },
  { family: "Tiro Devanagari Hindi", category: "serif" },
  { family: "Tiro Devanagari Marathi", category: "serif" },
  { family: "Tiro Devanagari Sanskrit", category: "serif" },
  { family: "Tiro Gurmukhi", category: "serif" },
  { family: "Tiro Kannada", category: "serif" },
  { family: "Tiro Kochi", category: "serif" },
  { family: "Tiro Tamil", category: "serif" },
  { family: "Tiro Telugu", category: "serif" },
  { family: "Titan One", category: "display" },
  { family: "Titillium Web", category: "sans-serif" },
  { family: "Tomorrow", category: "sans-serif" },
  { family: "Tourney", category: "display" },
  { family: "Trade Winds", category: "display" },
  { family: "Train One", category: "display" },
  { family: "Trirong", category: "serif" },
  { family: "Trispace", category: "sans-serif" },
  { family: "Trocchi", category: "serif" },
  { family: "Trochut", category: "display" },
  { family: "Truculenta", category: "sans-serif" },
  { family: "Trykker", category: "serif" },
  { family: "Tsukimi Rounded", category: "sans-serif" },
  { family: "Tulpen One", category: "display" },
  { family: "Turret Road", category: "display" },
  { family: "Twinkle Star", category: "handwriting" },
  { family: "Ubuntu", category: "sans-serif" },
  { family: "Ubuntu Condensed", category: "sans-serif" },
  { family: "Ubuntu Mono", category: "monospace" },
  { family: "Ubuntu Sans", category: "sans-serif" },
  { family: "Ubuntu Sans Mono", category: "monospace" },
  { family: "Uchen", category: "serif" },
  { family: "Ultra", category: "serif" },
  { family: "Unbounded", category: "sans-serif" },
  { family: "Underdog", category: "display" },
  { family: "Unica One", category: "display" },
  { family: "UnifrakturCook", category: "display" },
  { family: "UnifrakturMaguntia", category: "display" },
  { family: "Unkempt", category: "display" },
  { family: "Unlock", category: "display" },
  { family: "Unna", category: "serif" },
  { family: "Updock", category: "handwriting" },
  { family: "Urbanist", category: "sans-serif" },
  { family: "VT323", category: "monospace" },
  { family: "Vampiro One", category: "display" },
  { family: "Varela", category: "sans-serif" },
  { family: "Varela Round", category: "sans-serif" },
  { family: "Varta", category: "sans-serif" },
  { family: "Vast Shadow", category: "display" },
  { family: "Vazirmatn", category: "sans-serif" },
  { family: "Vesper Libre", category: "serif" },
  { family: "Viaoda Libre", category: "display" },
  { family: "Vibes", category: "display" },
  { family: "Vibur", category: "handwriting" },
  { family: "Vidaloka", category: "serif" },
  { family: "Viga", category: "sans-serif" },
  { family: "Vijaya", category: "serif" },
  { family: "Vina Sans", category: "display" },
  { family: "Voces", category: "sans-serif" },
  { family: "Volkhov", category: "serif" },
  { family: "Vollkorn", category: "serif" },
  { family: "Vollkorn SC", category: "serif" },
  { family: "Voltaire", category: "sans-serif" },
  { family: "Vujahday Script", category: "handwriting" },
  { family: "Waiting for the Sunrise", category: "handwriting" },
  { family: "Wallpoet", category: "display" },
  { family: "Walter Turncoat", category: "handwriting" },
  { family: "Warnes", category: "display" },
  { family: "Water Brush", category: "handwriting" },
  { family: "Waterfall", category: "handwriting" },
  { family: "Wavefont", category: "display" },
  { family: "Wellfleet", category: "display" },
  { family: "Wendy One", category: "sans-serif" },
  { family: "Whisper", category: "handwriting" },
  { family: "WindSong", category: "handwriting" },
  { family: "Wire One", category: "sans-serif" },
  { family: "Wix Madefor Display", category: "sans-serif" },
  { family: "Wix Madefor Text", category: "sans-serif" },
  { family: "Work Sans", category: "sans-serif" },
  { family: "Xanh Mono", category: "monospace" },
  { family: "Yanone Kaffeesatz", category: "sans-serif" },
  { family: "Yantramanav", category: "sans-serif" },
  { family: "Yarndings 12", category: "display" },
  { family: "Yarndings 20", category: "display" },
  { family: "Yatra One", category: "display" },
  { family: "Yellowtail", category: "handwriting" },
  { family: "Yeon Sung", category: "display" },
  { family: "Yeseva One", category: "display" },
  { family: "Yesteryear", category: "handwriting" },
  { family: "Yomogi", category: "handwriting" },
  { family: "Young Serif", category: "serif" },
  { family: "Yrsa", category: "serif" },
  { family: "Ysabeau", category: "sans-serif" },
  { family: "Ysabeau Infant", category: "sans-serif" },
  { family: "Ysabeau Office", category: "sans-serif" },
  { family: "Ysabeau SC", category: "sans-serif" },
  { family: "Yuji Boku", category: "serif" },
  { family: "Yuji Hentaigana Akari", category: "handwriting" },
  { family: "Yuji Hentaigana Akebono", category: "handwriting" },
  { family: "Yuji Mai", category: "serif" },
  { family: "Yuji Syuku", category: "serif" },
  { family: "Yusei Magic", category: "sans-serif" },
  { family: "ZCOOL KuaiLe", category: "display" },
  { family: "ZCOOL QingKe HuangYou", category: "display" },
  { family: "ZCOOL XiaoWei", category: "display" },
  { family: "Zen Antique", category: "serif" },
  { family: "Zen Antique Soft", category: "serif" },
  { family: "Zen Dots", category: "display" },
  { family: "Zen Kaku Gothic Antique", category: "sans-serif" },
  { family: "Zen Kaku Gothic New", category: "sans-serif" },
  { family: "Zen Kurenaido", category: "sans-serif" },
  { family: "Zen Loop", category: "display" },
  { family: "Zen Maru Gothic", category: "sans-serif" },
  { family: "Zen Old Mincho", category: "serif" },
  { family: "Zen Tokyo Zoo", category: "display" },
  { family: "Zeyada", category: "handwriting" },
  { family: "Zhi Mang Xing", category: "handwriting" },
  { family: "Zilla Slab", category: "serif" },
  { family: "Zilla Slab Highlight", category: "display" },
];
